/**
 * Free Shipping Bar - Dynamic cart progress indicator
 * SEO optimized: external, deferred loading
 */
(function() {
  'use strict';

  function initFreeShippingBars() {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    bars.forEach(function(container) {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      var threshold = parseFloat(container.dataset.threshold) || 49;
      var labelRemaining = container.dataset.labelRemaining || '';
      var labelReached = container.dataset.labelReached || '';
      var labelEmpty = container.dataset.labelEmpty || '';
      var textEl = container.querySelector('.bz-shipping-bar__text');
      var fillEl = container.querySelector('.bz-shipping-bar__fill');

      function applyUpdate(cart) {
        var totalCents = cart.total_price || 0;
        var totalEuros = totalCents / 100;
        var percentage = Math.min((totalEuros / threshold) * 100, 100);
        var remaining = threshold - totalEuros;

        requestAnimationFrame(function() {
          fillEl.style.width = percentage + '%';
        });

        if (totalEuros >= threshold) {
          fillEl.classList.add('bz-shipping-bar__fill--complete');
          textEl.innerHTML = labelReached;
        } else if (totalEuros > 0) {
          fillEl.classList.remove('bz-shipping-bar__fill--complete');
          textEl.innerHTML = labelRemaining.replace('{amount}', '<strong>' + remaining.toFixed(2).replace('.', ',') + '&euro;</strong>');
        } else {
          fillEl.classList.remove('bz-shipping-bar__fill--complete');
          textEl.innerHTML = labelEmpty.replace('{amount}', '<strong>' + threshold.toFixed(2).replace('.', ',') + '&euro;</strong>');
        }
      }

      // Deduplicazione fetch condiviso tra tutte le bar
      function fetchAndUpdate() {
        if (window.__freeShippingBarInflight) {
          window.__freeShippingBarInflight.then(applyUpdate).catch(function() {});
          return;
        }
        window.__freeShippingBarInflight = fetch('/cart.js')
          .then(function(res) { return res.json(); })
          .then(function(cart) {
            window.__freeShippingBarInflight = null;
            return cart;
          })
          .catch(function(err) {
            window.__freeShippingBarInflight = null;
            throw err;
          });
        window.__freeShippingBarInflight.then(applyUpdate).catch(function() {});
      }

      function updateShippingBar(cart) {
        if (cart) {
          applyUpdate(cart);
        } else {
          fetchAndUpdate();
        }
      }

      // Initial update (1 fetch al load)
      updateShippingBar();

      // Un solo listener cart:updated, legge dal detail quando disponibile
      document.addEventListener('cart:updated', function(e) {
        updateShippingBar(e.detail && e.detail.cart ? e.detail.cart : null);
      });

      // RIMOSSO: listener su documentElement (duplicato del precedente)
      // RIMOSSO: listener cart:change e cart:refresh (rifacevano fetch senza detail)
      // RIMOSSO: listener shopify:section:load (non rilevante per questo widget)
      // RIMOSSO: setInterval(2000) - era un polling infinito che causava 30 fetch/minuto per bar
    });
  }

  window.initFreeShippingBars = initFreeShippingBars;
  initFreeShippingBars();
})();